(function () {

  const sendChangeEvent = function(element) {
    setTimeout(function(){
      const event = new Event('change', {
        bubbles: true,
        cancelable: true
      });
      element.dispatchEvent(event);
    },500)
  }
  
  document.addEventListener("DOMContentLoaded", function () {
    document.addEventListener("input", function (event) {
      // Check if the clicked element matches the selector
      if (event.target && !event.target.classList.contains("quantity__input")) {
        return;
      }
        let element = event.target;
        let max = parseInt(element.dataset.max);
        let cartQuantity = parseInt(element.dataset.cartQuantity);
        let value = parseInt(element.value);

        if (
          event.target
            .closest("quantity-input")
            .classList.contains("cart-quantity")
        ) {
          if (value > max) {
            display_qty_error(
              `You can only add a maximum of ${max} in your cart.`,
              element
            );
            element.value = max;
            sendChangeEvent(element)
          }
        } else {
          if (value + cartQuantity > max) {
            if (cartQuantity > 0 && value + cartQuantity > max) {
              display_qty_error(
                  `You can only add a maximum of ${max} in your cart. You already have ${cartQuantity} in your cart.`,
                  element
                );
           
            } else {
               display_qty_error(
              `You can only add a maximum of ${max} in your cart.`,
              element
            );
            }

            if (value + cartQuantity <= max) {
              element.value = element.value + cartQuantity;
            } else {
              if (cartQuantity != max) {
                element.value = max - cartQuantity;
                 
              } else {
                element.value = 0;
              }
            }
          } else {
          }
 sendChangeEvent(element)

        }
    });
  });

  const display_qty_error = function (message, inputElement) {
    // Create error message element
    const error = document.createElement("div");
    error.textContent = message;
    error.classList = "smx-cart-qty-error";

    // Insert error message after input
    inputElement.parentNode.insertBefore(error, inputElement.nextSibling);

    // Remove error message after 2 seconds
    setTimeout(() => {
      if (error.parentNode) {
        error.parentNode.removeChild(error);
      }
    }, 3500);
  };
})();
